import React, { useMemo } from 'react';
import { Slot } from 'expo-router';

interface OptimizedSlotProps {
  fallback?: React.ReactNode;
}

export const OptimizedSlot: React.FC<OptimizedSlotProps> = React.memo(() => {
  // Simple memoization based on pathname
  const memoizedSlot = useMemo(() => {
    return <Slot />;
  }, []);

  return memoizedSlot;
});

OptimizedSlot.displayName = 'OptimizedSlot';
